export const goBack = () => {
    console.log("Hlloe")
    window.history.back();
}
